import type { AppConfig } from "@app/shared";

// Les deux classes sont ecrites en toutes lettres : Tailwind ne genere que ce qu'il lit.
const WIDTHS = { narrow: "max-w-3xl", wide: "max-w-6xl" } as const;

/** Colonne de lecture des pages de la couche Lab, quelle que soit la largeur de l'app. */
export const READING_WIDTH = "max-w-3xl";

/** Classe de largeur de la colonne commune (en-tete, contenu, pied de page). */
export function pageWidthClass(config: Pick<AppConfig, "layout">): string {
  return WIDTHS[config.layout?.width ?? "narrow"];
}
